import { skillsUsed } from "@utils/constants";
import { SkillInput } from "@pages/SearchPage/DetailPage";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

const dummyQualifications = [
  {
    title: "Incident response",
    importance: "Critical",
    requiredLevel: "Advanced",
    experience: "5+ years",
    recency: "Current",
    roleContext: "How this skill will be used",
    howSkillsIsUsed:
      "Applicants should show evidence of coordinating security incidents, working under pressure and turning incident learning into stronger controls.",
  },
  {
    title: "Security governance",
    importance: "Critical",
    requiredLevel: "Advanced",
    experience: "5+ years",
    recency: "Current",
    roleContext: "How this skill will be used",
    howSkillsIsUsed:
      "Applicants should show evidence of coordinating security incidents, working under pressure and turning incident learning into stronger controls.",
  },
  {
    title: "Stakeholder communication",
    importance: "Critical",
    requiredLevel: "Advanced",
    experience: "5+ years",
    recency: "Current",
    roleContext: "How this skill will be used",
    howSkillsIsUsed:
      "Applicants should show evidence of coordinating security incidents, working under pressure and turning incident learning into stronger controls.",
  },
];

const QualificationCard = ({ skill }) => {
  const [expandSkillUsed, setExpandSkillUsed] = useState(false);

  return (
    <div className="rounded-md border-l-[3px] border-r border-y border-l-slate-600 overflow-hidden">
      <div className="text-lg font-bold px-4 py-3 text-black">
        {skill?.title}
      </div>

      <div className="grid grid-cols-[0.9fr_0.9fr_0.9fr_0.9fr_1.4fr] items-center border-t h-16">
        <div className="flex flex-col flex-1 gap-1.5 pl-4">
          <span className="font-semibold text-xss tracking-wider uppercase text-light-black">
            Priority
          </span>
          <span className="text-xs font-bold text-black">
            {skill?.importance}
          </span>
        </div>

        <div className="flex flex-col flex-1 gap-1.5 border-l pl-4">
          <span className="font-semibold text-xss tracking-wider uppercase text-light-black">
            Type
          </span>
          <span className="text-xs font-bold text-black">
            {skill?.requiredLevel}
          </span>
        </div>

        <div className="flex flex-col flex-1 gap-1.5 border-l pl-4">
          <span className="font-semibold text-xss tracking-wider uppercase text-light-black">
            Minimum level
          </span>
          <span className="text-xs font-bold text-black">
            {skill?.experience}
          </span>
        </div>

        <div className="flex flex-col flex-1 gap-1.5 border-l pl-4">
          <span className="font-semibold text-xss tracking-wider uppercase text-light-black">
            Evidence
          </span>
          <span className="text-xs font-bold text-black">{skill?.recency}</span>
        </div>

        <button
          onClick={() => setExpandSkillUsed((prev) => !prev)}
          aria-expanded={expandSkillUsed}
          className="flex justify-between items-center flex-1 h-full gap-1.5 border-l px-4 bg-slate-100 hover:bg-slate-100"
        >
          <div className="flex flex-col gap-1.5">
            <span className="font-semibold text-xss tracking-wider uppercase text-light-black text-left">
              Qualification
            </span>
            <span className="text-xs font-bold text-black text-left">
              Why this is advantageous
            </span>
          </div>

          <div className="flex items-center justify-center w-7 h-7 rounded-full border bg-white shrink-0">
            <ChevronDown
              size={18}
              className={`transition-transform duration-200 ease-out ${
                expandSkillUsed ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>
        </button>
      </div>

      {expandSkillUsed ? (
        <div className="flex flex-col gap-1 border-t p-4">
          <span className="font-bold text-xss text-light-black tracking-wider uppercase">
            How this skill is used in the role
          </span>
          <span className="text-xs font-medium text-charcoal leading-4">
            {skill?.howSkillsIsUsed}
          </span>
        </div>
      ) : null}
    </div>
  );
};

const Qualitfications = ({ data }) => {
  return (
    <div className="flex flex-col flex-1 min-h-0 overflow-y-scroll no-scrollbar">
      <div className="flex flex-col gap-1 border-b pb-5">
        <span className="font-semibold text-md">
          Qualifications requested from applicants
        </span>
        <span className="text-xs text-light-black font-medium">
          Essential and advantageous credentials are separated so applicants can
          understand what is required and what strengthens an application.
        </span>
      </div>

      {/* Qualifications list */}
      <div className="flex flex-col mt-4 gap-5">
        {dummyQualifications?.map((skill) => {
          return <QualificationCard skill={skill} />;
        })}
      </div>
    </div>
  );
};

export default Qualitfications;
